module.exports = __webpack_public_path__ + "img/task-icon.df2614bd.svg";